import { Options } from '@angular-slider/ngx-slider';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { masks } from 'src/app/services/input-masks';
import { InterpolationService } from 'src/app/services/interpolation.service';
import { QuestionService } from 'src/app/services/question.service';


@Component({
  selector: 'app-slider-question',
  templateUrl: './slider-question.component.html',
  styleUrls: ['./slider-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class SliderQuestionComponent implements OnInit, OnDestroy {
  @Input() question: QQQuestionViewModel;

  value = 0;
  textValue = "";
  options: Options = { floor: 0, ceil: 100 };
  displayValue: string;
  destroy$ = new Subject();
  mask: MaskitoOptions;

  constructor(
    private interpolator: InterpolationService,
    private questionService: QuestionService
  ) {
  }

  ngOnInit() {
    this.setup();
    if (this.question.options.calculate) {
      const keys = Object.values(this.question.options.calculate).join(",");
      this.question.page.onQuestionAnswered.pipe(
        filter(x => keys.indexOf(x.question.key) >= 0),
        takeUntil(this.destroy$),
        tap(x => this.setup())
      ).subscribe();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  private setup() {
    let opts = this.questionService.getCalculatedOptions(this.question);
    this.value = parseInt(this.question.answer) || opts.initialValue || opts.floor || 0;
    if (opts.floor === opts.ceil)
      this.value = opts.floor;
    this.textValue = this.value.toString();
    this.options = opts;

    this.question.setAnswer(this.textValue, true);
    const translate = this.question.options.translate;
    if (translate) {
      this.options.translate = (value: any) => this.interpolator.interpolate(translate, { value });
    }
    if (this.question.options.mask) {
      this.mask = masks[this.question.options.mask];
    }
  }

  sliderEvent(evt: any) {
    this.textValue = evt;
    this.save();
  }

  updateSlider(evt: any) {
    this.value = evt;
    this.save();
  }

  async apply() {
    if (!this.textValue)
      this.textValue = (this.options?.floor || 0).toString();
    this.value = parseInt(this.textValue.replace(/\D+/, ''));
  }

  reset() {
  }

  async save() {
    await this.question.setAnswer(this.value.toString(), true);
  }
}
